import * as React from 'react';
import  request  from '@/server/request';
import config from '@/server/config';
import alert from '@/pages/components/common/alert';
import './scss/form.scss'

interface initProps {
	history: any,
}

class BindEmail extends React.Component <initProps , any> {
	constructor(props: any) {
		super(props);
		this.state = {
			isSubmit: false,
			email: '', 
		};
	}

	componentDidMount() {
		function GetQueryString(name: any) {
	        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	        var r = window.location.search.substr(1).match(reg);
	        if (r != null) return unescape(r[2]);
	        return null;
	    }
	   	const email = GetQueryString('email');
	   	this.setState({
	   		email: email ? email : '',
	   	})

	}

	render() {
		return (
			<div className="page-replacePhone gray-bg">
				<div className="default-form">
					<div className="form-input-warrper">
						<label className="label">电子邮箱</label>
						<input type="text" placeholder="请输入邮箱"  value={this.state.email} onChange={ (e:any) => this.setState({ email: e.target.value }) } />
					</div>
				</div>

				<div className="form-btn-warrrper">
					<button className="form-btn" onClick={() => this.submitForm()}>保存</button>
				</div>
			</div>
		)
	}

	private checkForm() {
		if(this.state.email.replace(/\s/gi, '') === '') {
			alert.open({
				promptText: '请输入手机号',
			})
			return;
		}

		if(!/^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/gi.test(this.state.email)) {
			alert.open({
				promptText: '邮箱格式有误！',
			})

			return ;
		}


		return true;
	}

	private submitForm() {
		const that = this;
		if(this.state.isSubmit) {
			return ;
		}

		if(that.checkForm()) {
			this.setState({
				isSubmit: true,
			}, () => {
				const data = request({
					method: "post",
					url: `${config.CE}member/info/basic/save`,
					data: {
						email: this.state.email,
						updateType: 'email',
					}
				});
				data.then(r => {
					if(r.code !== 1) {
						alert.open({
							promptText: r.msg,
							callback: () => {
								that.setState({
									isSubmit: false,
									email: '',
								})
							}
						})
					}else {
						alert.open({
							promptText: '邮箱更改成功！',
							callback: () => {
								that.setState({
									isSubmit: false,
									email: '',
								},() => that.props.history.push('/userInfo'))
								
							}
						})
					}
				})
			})
		}
	}	
}

export default BindEmail;